import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";

function AlertPopUp(props) {
  const [buttonClicked, setButtonClicked] = useState(false);

  const handleAddRequest = (event, index) => {
    setButtonClicked(true);
    props.performWarningAction(event, index);
  };

  let closeModal = () => {};
  return (
    <Modal
      show={props.showConfirmPopup}
      onHide={closeModal}
      className="remove-crop"
    >
      <Modal.Header>
        <h3>{props.header}</h3>
      </Modal.Header>
      <Modal.Body>
        <p color="muted">
          {props.message} <br />
        </p>
        <Button
          type="button"
          onClick={(e) => handleAddRequest(e, props.index)}
          disabled={buttonClicked ? true : false}
        >
          Yes
        </Button>{" "}
        <Button
          type="button"
          onClick={(e) => props.closeWarningPopup(e)}
          disabled={buttonClicked ? true : false}
        >
          No
        </Button>
      </Modal.Body>
    </Modal>
  );
}

export default AlertPopUp;
